import { render, staticRenderFns } from "./ExpansionPanelContentFixable.vue?vue&type=template&id=4e9a53a0&scoped=true&"
import script from "./ExpansionPanelContentFixable.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanelContentFixable.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelContentFixable.vue?vue&type=style&index=0&id=4e9a53a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a53a0",
  null
  
)

export default component.exports